import { sendRequest } from './request'
import { AxiosPromise } from 'axios'
import { CategoryDto } from '../model/typegen/categoryDto';

const path = '/api/media/'

export const getMediaCategoryList = (identifier: string): AxiosPromise<Array<CategoryDto>> => {
    return sendRequest(path + 'MediaByClassification?identifier=' + identifier, 'get');
}